import { render, staticRenderFns } from "./IntraWorkTable.vue?vue&type=template&id=484aec7f&scoped=true&"
import script from "./IntraWork.js?vue&type=script&lang=js&"
export * from "./IntraWork.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484aec7f",
  null
  
)

export default component.exports